export class EventPromise {

    constructor(element:JQuery<HTMLElement>, event:string) {
        return new Promise((resolve, reject) => {
            element.off(event);
            element.one(event, () => resolve(true));
        });
    }
}

export {};